import { render, staticRenderFns } from "./bookerTour.vue?vue&type=template&id=10435779&scoped=true"
import script from "./bookerTour.vue?vue&type=script&setup=true&lang=js"
export * from "./bookerTour.vue?vue&type=script&setup=true&lang=js"
import style0 from "./bookerTour.vue?vue&type=style&index=0&id=10435779&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10435779",
  null
  
)

export default component.exports